const ImagePicker = {
  openPicker: async (_options) => {
    return new Promise((resolve) => {
      if (typeof document === 'undefined') return resolve(null);
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = (e) => {
        const file = e.target?.files?.[0];
        if (file) {
          const path = URL.createObjectURL(file);
          resolve({
            path,
            mime: file.type,
            size: file.size,
            filename: file.name,
          });
        } else {
          resolve(null);
        }
      };
      input.click();
    });
  },
  openCamera: async (options) => ImagePicker.openPicker(options),
  clean: async () => {},
  cleanSingle: async () => {},
};

module.exports = ImagePicker;
module.exports.default = ImagePicker;
